if ("function" != typeof ProductSlider) {
  class t extends HTMLElement {
    constructor() {
      super();
      let t = navigator.userAgent.toLowerCase();
      (this._ios15 =
        ("ontouchstart" in window ||
          (window.DocumentTouch && document instanceof DocumentTouch)) &&
        t.includes("applewebkit") &&
        (t.includes("os 15_") || t.includes("version/15"))),
        this.classList.add("js-enabled"),
        (this.viewport = this.querySelector(".product-gallery__viewport")),
        (this.container = this.querySelector(".product-gallery__container")),
        (this.holder = this.querySelector(".product-gallery__items")),
        (this.items = this.querySelectorAll(".product-gallery__item")),
        (this.index = this.dataset.initialIndex
          ? parseInt(this.dataset.initialIndex)
          : 0),
        (this.length = this.items.length),
        (this.timeout = null),
        (this.animating = !1),
        (this._mobilePadding = parseInt(
          window
            .getComputedStyle(document.documentElement)
            .getPropertyValue("--grid-padding")
        )),
        (this.changeSlide = (t) => {
          if (this.mobile)
            this._iOS15snapping(),
              this.holder.scrollTo({
                left:
                  this.items[t].offsetLeft -
                  parseInt(getComputedStyle(this.items[t]).marginLeft),
                top: 0,
                behavior: "smooth",
              }),
              this._checkNav(t),
              this._checkIndex(!0),
              this._setHeight();
          else if (
            (this._blockAnimation(!0), this._resetClasses(), t > this.index)
          ) {
            let s = this.index;
            (this.index = t - 1),
              this.holder.classList.add("no-transitions"),
              this._resetClasses(),
              this._resetOrder([s, this.index]),
              (this.holder.style.transform = `translateX(${-(
                this.index *
                this.width *
                1
              )}px`),
              this.items[s].classList.add("active"),
              this.items[t].classList.add("after-active"),
              this._checkNav(t),
              setTimeout(() => {
                this.holder.classList.remove("no-transitions"),
                  this.items[s].classList.remove("active"),
                  this.items[s].classList.add("before-active"),
                  (this.holder.style.transform = `translateX(${-(
                    t *
                    this.width *
                    1
                  )}px`),
                  this.items[t].classList.remove("after-active"),
                  this.items[t].classList.add("active"),
                  (this.index = t),
                  this.dispatchEvent(this.EVENT_CHANGE);
              }, 10);
          } else if (t < this.index) {
            let e = this.index;
            (this.index = t + 1),
              this.holder.classList.add("no-transitions"),
              this._resetClasses(),
              this._resetOrder([e, this.index]),
              (this.holder.style.transform = `translateX(${-(
                this.index *
                this.width *
                1
              )}px`),
              this.items[e].classList.add("active"),
              this.items[t].classList.add("before-active"),
              this._checkNav(t),
              setTimeout(() => {
                this.holder.classList.remove("no-transitions"),
                  this.items[e].classList.remove("active"),
                  this.items[e].classList.add("after-active"),
                  (this.holder.style.transform = `translateX(${-(
                    t *
                    this.width *
                    1
                  )}px`),
                  this.items[t].classList.remove("before-active"),
                  this.items[t].classList.add("active"),
                  (this.index = t),
                  this.dispatchEvent(this.EVENT_CHANGE);
              }, 10);
          }
          this._setHeight(t);
        }),
        (this.toggleDragging = (t) => {
          t
            ? this.container.classList.remove("force-no-drag")
            : this.container.classList.add("force-no-drag");
        }),
        (this.EVENT_CHANGE = new Event("change")),
        (this.EVENT_SETTLE = new Event("settle"));
      let s = document.createElement("div");
      s.setAttribute(
        "class",
        `product-gallery__navigation ${
          this.dataset.navClass
            ? this.dataset.navClass
            : "five-tenths lap--six-tenths smaller-lap--eleven-tenths push-left-one-tenth lap--push-left-none smaller-lap--push-left-padding"
        }`
      ),
        (s.innerHTML = `
        <div class="product-gallery__no">
          <span class="product-gallery__index">${this.index + 1}</span> / ${
          this.length
        }
        </div>
        <button class="product-gallery__prev simple-arrow simple-arrow--left">
          <span class="visually-hidden">${KROWN.settings.locales.prev}</span>
          ${KROWN.settings.symbols.arrow}
        </button>
        <button class="product-gallery__next simple-arrow simple-arrow--right">
          <span class="visually-hidden">${KROWN.settings.locales.next}</span>
          ${KROWN.settings.symbols.arrow}
        </button>`),
        this.appendChild(s),
        (this.indexEl = this.querySelector(".product-gallery__index")),
        (this.prevEl = this.querySelector(".product-gallery__prev")),
        (this.nextEl = this.querySelector(".product-gallery__next")),
        this.prevEl.addEventListener("click", () => {
          this.prevSlide();
        }),
        this.nextEl.addEventListener("click", () => {
          this.nextSlide();
        }),
        this.querySelectorAll(
          ".product-gallery__prev, .product-gallery__next"
        ).forEach((t) => {
          t.addEventListener("keydown", (t) => {
            t.keyCode == window.KEYCODES.RETURN &&
              ((window.scrollY = this.container.offsetTop - 100),
              setTimeout(() => {
                this.items[this.index].focus();
              }, 50));
          });
        }),
        this.container.addEventListener(
          "touchstart",
          (t) => {
            this.mobile ||
              this.container.classList.contains("force-no-drag") ||
              ((this.touchX = t.touches[0].screenX),
              this.container.classList.add("dragging-enabled"));
          },
          { passive: !0 }
        ),
        this.container.addEventListener(
          "touchmove",
          (t) => {
            if (
              !this.mobile &&
              this.container.classList.contains("dragging-enabled") &&
              !this.container.classList.contains("force-no-drag")
            ) {
              let s = this.touchX - t.touches[0].screenX;
              s > 0
                ? (this.nextSlide(),
                  this.container.classList.remove("dragging-enabled"))
                : s < 0 &&
                  (this.prevSlide(),
                  this.container.classList.remove("dragging-enabled"));
            }
          },
          { passive: !0 }
        ),
        this.container.addEventListener(
          "touchend",
          (t) => {
            this.mobile || this.container.classList.remove("dragging-enabled");
          },
          { passive: !0 }
        ),
        this.container.addEventListener("mousedown", (t) => {
          this.mobile ||
            this.container.classList.contains("force-no-drag") ||
            ((this.mouseX = t.screenX),
            this.container.classList.add("dragging-enabled"),
            this.container.classList.add("mouse-down"));
        }),
        this.container.addEventListener("mouseup", (t) => {
          this.mobile ||
            (this.container.classList.remove("mouse-down"),
            this.container.classList.remove("pointer-events-off"),
            this.container.classList.remove("dragging-enabled"));
        }),
        this.container.addEventListener("mousemove", (t) => {
          if (
            !this.mobile &&
            this.container.classList.contains("dragging-enabled") &&
            !this.container.classList.contains("force-no-drag")
          ) {
            let s = this.mouseX - t.screenX;
            Math.abs(s) > 1 &&
              (this.container.classList.add("pointer-events-off"),
              s > 0
                ? (this.nextSlide(),
                  this.container.classList.remove("dragging-enabled"))
                : s < 0 &&
                  (this.prevSlide(),
                  this.container.classList.remove("dragging-enabled")));
          }
        }),
        (this.OBSERVER = new IntersectionObserver(
          (t) => {
            this.mobile &&
              t.forEach((t) => {
                t.intersectionRatio >= 0.3 &&
                  ((this.index = parseInt(t.target.getAttribute("data-index"))),
                  this._checkNav(),
                  this._checkIndex(!0),
                  this._setHeight(),
                  this.dispatchEvent(this.EVENT_CHANGE));
              });
          },
          { threshold: [0, 0.3] }
        )),
        this.items.forEach((t) => {
          this.OBSERVER.observe(t);
        }),
        this._checkMobile(),
        this._resetOrder(),
        this._checkIndex(),
        this._checkNav(),
        this._setHeight(),
        this._getSliderWidth(),
        setTimeout(() => {
          this._getSliderWidth(), this._repositionSlider();
        }, 100),
        this._repositionSlider(),
        (this.EVENT_RESIZE = () => {
          this._checkMobile(),
            this._setHeight(),
            this._getSliderWidth(),
            this._repositionSlider(),
            (this._mobilePadding = parseInt(
              window
                .getComputedStyle(document.documentElement)
                .getPropertyValue("--grid-padding")
            ));
        }),
        window.addEventListener("resize", this.EVENT_RESIZE),
        this.items[this.index].classList.add("enable-tab"),
        this.mobile &&
          (this.holder.scrollLeft = this.items[this.index].offsetLeft);

      (this.autoplayEnabled = this.dataset.autoplayEnabled === 'true');
      (this.autoplayDuration = parseInt(this.dataset.autoplayDuration) || 3000);

      this.autoplayTimer = null;

      this.startAutoplay = function() {
          if (this.autoplayEnabled) {
              this.autoplayTimer = setInterval(() => {
                  this.nextSlide();
              }, this.autoplayDuration);
          }
      };

      this.stopAutoplay = function() {
        clearInterval(this.autoplayTimer);
      };

      this.addEventListener('mouseenter', () => {
        this.stopAutoplay();
      });

      this.addEventListener('mouseleave', () => {
          this.startAutoplay();
      });

      this.startAutoplay();

    }
    _checkMobile() {
      -1 != getComputedStyle(this, ":after").content.indexOf("mobile-enabled")
        ? (this.mobile = !0)
        : (this.mobile = !1);
    }
    _checkIndex(t = !1) {
      t && this._resetClasses(),
        this.items[this.index].classList.add("active"),
        this.items[this.index + 1] &&
          this.items[this.index + 1].classList.add("after-active"),
        this.items[this.index - 1] &&
          this.items[this.index - 1].classList.add("before-active"),
        t || (this.indexEl.innerHTML = this.index + 1);
    }
    _checkNav(t = null) {
      let s = null != t ? t : this.index;
      this.nextEl.classList.remove("active"),
        this.nextEl.classList.remove("disabled"),
        this.prevEl.classList.remove("disabled"),
        this.nextEl.removeAttribute("disabled"),
        this.prevEl.removeAttribute("disabled"),
        this.items[s + 1] ||
          (this.nextEl.classList.add("disabled"),
          this.nextEl.setAttribute("disabled", "disabled")),
        this.items[s - 1] ||
          (this.prevEl.classList.add("disabled"),
          this.prevEl.setAttribute("disabled", "disabled")),
        (this.indexEl.innerHTML = s + 1);
    }
    _getSliderWidth() {
      this.width = this.items[0].getBoundingClientRect().width;
    }
    _repositionSlider() {
      this.holder.classList.add("no-transitions"),
        (this.holder.style.transform = `translateX(${-(
          this.index *
          this.width *
          1
        )}px`),
        setTimeout(() => {
          this.holder.classList.remove("no-transitions");
        }, 10);
    }
    _resetClasses() {
      this.items.forEach((t) => {
        t.classList.remove("before-active"),
          t.classList.remove("after-active"),
          t.classList.remove("active");
      });
    }
    _resetOrder(t = null) {
      this.items.forEach((s, e) => {
        let i = e;
        null != t && (e == t[0] ? (i = t[1]) : e == t[1] && (i = t[0])),
          (s.style.order = i);
      });
    }
    _translateSlider() {
      (this.holder.style.transform = `translateX(${-(
        this.index *
        this.width *
        1
      )}px`),
        this._checkIndex(),
        this._checkNav();
    }
    _blockAnimation(t = !1) {
      (this.animating = !0),
        (this.timeout = setTimeout(() => {
          (this.animating = !1),
            this.dispatchEvent(this.EVENT_SETTLE),
            t && (this._resetOrder(), this._resetClasses(), this._checkIndex());
        }, 500));
    }
    _setHeight(t = null, s = !0) {
      let e = null != t ? t : this.index;
      s || this.viewport.classList.add("no-transition"),
        this.items[e].querySelector(".lazy-image") &&
          (this.viewport.style.height = `${
            this.items[e].querySelector(".lazy-image").offsetHeight
          }px`),
        s ||
          setTimeout(() => {
            this.viewport.classList.remove("no-transition");
          }, 20);
    }
    _iOS15snapping() {
      this._ios15 && this.holder.classList.add("disable-snapping"),
        setTimeout(() => {
          this._ios15 && this.holder.classList.remove("disable-snapping");
        }, 500);
    }
    nextSlide() {
        if (this.mobile) {
            // Mobile behavior
            if (this.index + 1 < this.length) {
                this.index++;
            } else {
                this.index = 0; // Loop back to the first slide
            }
            this._iOS15snapping();
            this.holder.scrollTo({
                left: this.items[this.index].offsetLeft - parseInt(getComputedStyle(this.items[this.index]).marginLeft),
                top: 0,
                behavior: "smooth"
            });
            this._setHeight();
            this._checkNav();
            this._checkIndex(!0);
        } else {
            // Desktop behavior
            if (!this.animating) {
                this._blockAnimation();
                if (this.index + 1 < this.length) {
                    this.index++;
                } else {
                    this.index = 0; // Loop back to the first slide
                }
                this._resetClasses();
                this._checkIndex();
                this._checkNav();
                this._setHeight();
                this._translateSlider();
                this.dispatchEvent(this.EVENT_CHANGE);
            }
        }
    }
    prevSlide() {
      this.mobile
        ? (this.index - 1 >= 0 && this.index--,
          this._iOS15snapping(),
          this.holder.scrollTo({
            left:
              this.items[this.index].offsetLeft -
              parseInt(getComputedStyle(this.items[this.index]).marginLeft),
            top: 0,
            behavior: "smooth",
          }),
          this._setHeight(),
          this._checkNav(),
          this._checkIndex(!0))
        : this.animating ||
          (this._blockAnimation(),
          this._resetClasses(),
          this.index - 1 >= 0 && this.index--,
          this._checkIndex(),
          this._checkNav(),
          this._setHeight(),
          this._translateSlider(),
          this.dispatchEvent(this.EVENT_CHANGE));
    }
  }
  void 0 === customElements.get("product-slider") &&
    customElements.define("product-slider", t);
}
